import './UploadTagSheetContentWrapper.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

type Props = {
  children: React.ReactNode;
  scrollable?: boolean;
};

const [block] = bem('upload-tag-sheet-content');

const UploadTagSheetContentWrapper = ({ children, scrollable = false }: Props): React.JSX.Element => {
  return <div className={scrollable ? `${block()} ${block('scrollable')}` : block()}>{children}</div>;
};

export default UploadTagSheetContentWrapper;
